module.exports = __webpack_public_path__ + "static/image/font/pc/bmhanna11yrs-5@3x.ver2_0_2.jpg?7c444a8f";